var __webpack_error__ = new Error();
module.exports = new Promise((resolve, reject) => {
	if(typeof on_boarding !== "undefined") return resolve();
	__webpack_require__.l("https://test-admin.dev.dim.atea.com/on-boarding/remoteEntry.js", (event) => {
		if(typeof on_boarding !== "undefined") return resolve();
		var errorType = event && (event.type === 'load' ? 'missing' : event.type);
		var realSrc = event && event.target && event.target.src;
		__webpack_error__.message = 'Loading script failed.\n(' + errorType + ': ' + realSrc + ')';
		__webpack_error__.name = 'ScriptExternalLoadError';
		__webpack_error__.type = errorType;
		__webpack_error__.request = realSrc;
		reject(__webpack_error__);
	}, "on_boarding");
}).then(() => (on_boarding));